import React from 'react'
import { Link } from 'gatsby'

import { UncontrolledCollapse } from 'reactstrap'
// import '../../components/menu.css'

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faTimes } from "@fortawesome/free-solid-svg-icons"
// import { faCaretDown } from "@fortawesome/free-solid-svg-icons"

// import { FaTimes, FaCaretDown } from 'react-icons/fa'

const Menu = ({ toggle }) => {
  const menus = [
    {
      title: '8A SOLE SOURCE ADVANTAGES',
      to: '/8a-sole-source-advantages/',
      subMenus: [],
    },
    {
      title: 'OUR SERVICES',
      to: '/our-services/',
      subMenus: [],
    },
    {
      title: 'PERIN INSIGHTS',
      to: '/news/',
      subMenus: [],
    },
    {
      title: 'DATA ENCRYPTION',
      to: '/data-encryption/',
      subMenus: [],
    },
    {
      title: 'ABOUT US',
      to: '/about-us/',
      subMenus: [],
    },
    {
      title: 'CONTACT US',
      to: '/contact-us/',
      subMenus: [],
    },
  ]

  const SubMenu = ({ to, title, subMenus }) => {
    // console.log(title)
    const mainIndexString = title.replace(/ /g, '_')

    return (
      <div>
        <div className="submenu-link d-flex">
          <MenuLink to={to}>{title}</MenuLink>
          <div
            className="d-flex justify-content-end caret-down-box"
            style={{ flex: 1, paddingRight: '30px' }}
            id={mainIndexString}
          >
            {/* <FaCaretDown
              style={{
                color: '#05324e',
                cursor: 'pointer',
                fontSize: '2.5rem',
                height: 'auto',
              }}
            /> */}
          </div>
        </div>
        {/* <div
          id={mainIndexString}
          style={{
            padding: "15px 8px 15px 16px",
            borderBottom: "solid 1px #3C3735",
            color: "#818181",
            cursor: "pointer",
          }}
          className="text-uppercase"
        >
          Testing
        </div> */}

        <UncontrolledCollapse toggler={mainIndexString}>
          <div className="d-flex flex-column">
            {subMenus.map((item, index) => (
              <MenuLink key={index} to={item.to}>
                {item.title}
              </MenuLink>
            ))}
          </div>
        </UncontrolledCollapse>
      </div>
    )
  }

  const MenuLink = ({ to, children }) => {
    return (
      <Link
        className="menu-links py-3"
        to={to}
        style={{
          fontFamily: 'Montserrat',
          fontStyle: 'bold',
          fontSize: '18px',
          fontWeight: 500,
          /* padding: 1px 100px 1px 1px; */
          letterSpacing: '0.2px',
          color: '#003B3D',
          // marginRight: '5vw',
        }}
      >
        {children}
      </Link>
    )
  }

  return (
    <>
      <div
        className="d-flex flex-column text-left menu-sidebar-wrapper"
        style={{ padding: '1.5rem 1.5rem' }}
      >
        {/* <div className="close-box text-left p-3">
          <button onClick={toggle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
            </svg>
          </button>
        </div> */}
        <div className="text-center my-4">
          <Link to="/">
            <img
              // className="logo"
              src="../images/Perin_Logo_Horizontal_V5.svg"
              alt="Site Logo"
            />
          </Link>
        </div>
        {menus.map((item, index) => {
          if (item.subMenus.length > 0)
            return (
              <SubMenu
                key={index}
                toggle={toggle}
                title={item.title}
                subMenus={item.subMenus}
                mainIndex={index}
                to={item.to}
              />
            )
          return <MenuLink to={item.to}>{item.title}</MenuLink>
        })}
      </div>
    </>
  )
}

export default Menu
